import React from 'react';
import PropTypes from 'prop-types';

import Filter from './filter';

export default function CompPropertyTypeFilter({ query, onChange }) {
  return (
    <Filter
      label="Property type"
      name="researchPropertyPropertyTypeMappingsPropertyTypeIdOrResearchPropertyPropertyTypeMappingsPropertySubtypeIdEq"
      query={query}
      type="select"
      onChange={onChange}
    >
      <option value="">All Property Types</option>
      <option value="1">Office</option>
      <option value="2">Retail</option>
      <option value="3">Industrial</option>
      <option value="5">Land</option>
      <option value="6">Multifamily</option>
      <option value="7">Special Purpose</option>
      <option value="8">Hospitality</option>
      <option value="104">Medical Office</option>
      <option value="605">Mobile Home Park</option>
    </Filter>
  );
}

CompPropertyTypeFilter.propTypes = {
  query: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};
